import { FirebaseApp, initializeApp } from 'firebase/app';
import * as React from 'react';

const FirebaseAppContext = React.createContext<FirebaseApp>(undefined);

function FirebaseAppProvider({ children }) {
  const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
  };

  const value = initializeApp(firebaseConfig);

  return (
    <FirebaseAppContext.Provider value={value}>
      {children}
    </FirebaseAppContext.Provider>
  );
}
const useFirebaseApp = () => {
  return React.useContext(FirebaseAppContext);
};

export { FirebaseAppProvider, useFirebaseApp };
